export default __webpack_public_path__ + "static/media/wood@2x.604cadb8.png";